<template>
  <Progressbar v-if="loading && !meta.current_page" />
  <NetworkError v-else-if="!notifications.length && errors" />
  <div class="flex flex-col w-full h-full" v-else>
    <div class="flex">
    <div class="alert bg-blue-custom-6 text-blue-custom-7">
      <span class="mx-auto">{{ __('Message box') }}</span>
    </div>
    <label class="btn btn-error btn-outline mr-3" for="delete-modal" @click="setNotification(null)" v-if="notifications.length">{{ __('Delete notifications of the last 30 days') }}</label>
  </div>
    <div class="card mt-4 bg-white !overflow-visible" v-if="notifications.length">
      <div class="card-body p-0">
        <div class="overflow-x-auto w-full">
          <table class="table w-full">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ __('Title') }}</th>
                <th>{{ __('shipping time') }}</th>
                <th>{{ __('Status') }}</th>
                <th>{{ __('Action') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="odd:bg-gray-custom-6" v-for="(item, index) in notifications">
                <td>
                  <button class="btn btn-sm btn-circle btn-ghost btn-disabled bg-orange-custom-5 !text-orange-custom-6">
                    {{ index + 1 }}</button>
                </td>
                <td class="truncate max-w-xs">{{ item.title }}</td>
                <td><div class="badge py-3 bg-purple-custom-1 border-0 text-purple-custom-3 px-1">{{ item.created_at }}</div></td>
                <td>
                  <div class="badge py-3 border-0" :class="[item.read_at ? 'bg-green-custom-2 text-green-custom-3' : 'bg-red-custom-3 border-0 text-red-custom-4']">{{ __(item.read_at ?
                      'read' :
                      'Unread')
                  }}</div>
                </td>
                <td>
                  <label class="btn btn-success btn-sm ml-2" for="notification" @click="setNotification(item)">
                    <EyeIcon class="w-5 h-5" />
                  </label>
                  <label class="btn btn-error btn-sm" for="delete-modal"
                                            @click="setNotification(item,'delete')">
                                            <TrashIcon class="w-5 h-5" />
                                        </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <NotFound v-else />
    <LoadMore v-if="meta.current_page < meta.last_page" :errors="errors"
      @tryAgain="getNotifications(meta.current_page + 1)" />
  </div>
  <Teleport to="#app">
    <input type="checkbox" id="notification" class="modal-toggle" />
    <div class="modal" id="modal-notification" v-if="notification">
      <div class="modal-box relative">
        <label for="notification" class="btn btn-sm btn-circle absolute left-2 top-2"
          @click="mark(notification.id)">✕</label>
        <h3 class="font-bold text-lg mt-3">{{ notification.title }}</h3>
        <p class="py-4 whitespace-pre-line" v-html="notification.message"></p>
      </div>
    </div>
  </Teleport>
  <Teleport to="#app">
        <input type="checkbox" id="delete-modal" class="modal-toggle" />
  <label class="modal" for="delete-modal">
    <label class="modal-box" for="">
      <h3 class="font-bold text-lg">{{ __(notification?.id ? 'Delete the notification' : 'Delete notifications of the last 30 days') }}</h3>
      <p class="py-4">{{ __(notification?.id ? 'Are you sure to delete this notification?' : 'Are you sure of removing notifications for the last 30 days?') }}</p>
      <div class="modal-action">
        <label class="btn btn-primary btn-sm" for="delete-modal">{{ __('Cancel') }}</label>
        <label class="btn btn-error btn-sm" @click="destroy(notification?.id)" for="delete-modal">{{ __('Delete') }}</label>
      </div>
    </label>
  </label>
    </Teleport>
</template>
<script setup>

import { onMounted } from "vue";
import { EyeIcon,TrashIcon } from '@heroicons/vue/24/outline'
import useNotification from "../../../composables/shop/notification";
import Auth from "../../../composables/shop/auth";
const { notifications, notification, getNotifications,destroy, mark, meta, loading, errors } = useNotification();
const setNotification = (item,type) => {
  notification.value = item;
  if(type != 'delete'){
    Auth.user.value.notification = 0;
    Auth.isNotification.value = false;
  }
}
onMounted(() => {
  getNotifications();
  document.querySelector('.drawer-content').addEventListener('scroll', (e) => {
    const scrollbar = e.target;
    if (meta.current_page < meta.last_page && !loading.value && !errors.value && (scrollbar.scrollTop + scrollbar.offsetHeight) >= (scrollbar.scrollHeight - 8)) {
      getNotifications(meta.current_page + 1);
    }
  });
});
</script>